/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageResponseDto
 */
export interface MessageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MessageResponseDto
     */
    message?: string | null;
}

/**
 * Check if a given object implements the MessageResponseDto interface.
 */
export function instanceOfMessageResponseDto(value: object): value is MessageResponseDto {
    return true;
}

export function MessageResponseDtoFromJSON(json: any): MessageResponseDto {
    return MessageResponseDtoFromJSONTyped(json, false);
}

export function MessageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function MessageResponseDtoToJSON(json: any): MessageResponseDto {
    return MessageResponseDtoToJSONTyped(json, false);
}

export function MessageResponseDtoToJSONTyped(value?: MessageResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

